/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDeposits = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M20 22H4V8H2V2h20v6h-2zM18 8H6l.001 8.1A5.006 5.006 0 0 1 9.9 20h4.2a5.006 5.006 0 0 1 3.9-3.9zM6 18.17V20h1.83l-.071-.18A3.01 3.01 0 0 0 6 18.17zm12 0A3.009 3.009 0 0 0 16.17 20H18zM12 9a4 4 0 1 1 0 8 4 4 0 0 1 0-8zm0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm8-7H4v2h16z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgDeposits as Deposits };
